import React, { useEffect, useRef, useState } from "react";
import { supabase } from "../supabase/supabaseClient";
import { Terminal } from "xterm";
import "xterm/css/xterm.css"; // Import xterm styles
import { ethers } from "ethers"; 

interface TradeTerminalProps {
  telegramId: string;
}

interface TradeLog {
  message: string;
  time: number;
}

const TradeTerminal: React.FC<TradeTerminalProps> = ({ telegramId }) => {
  const terminalEl = useRef<any>(null);
  const [tradeLogs, setTradeLogs] = useState<TradeLog[]>([]);
  const [terminal, setTerminal] = useState<Terminal | null>(null);

  const fetchLogs = async () => {
    try {
      const now = new Date();
      const threeMinutesAgo = new Date(now.getTime() - 3 * 60 * 1000);

      // Fetch the latest log within the last 3 minutes
      const { data, error } = await supabase
        .from("Trade_Logs")
        .select("log_data, id")
        .eq("telegram_id", telegramId)
        .eq("is_first_entry", true)
        .gte("created_at", threeMinutesAgo.toISOString())
        .lte("created_at", now.toISOString())
        .order("created_at", { ascending: false })
        .limit(1)
        .single();

      if (error) {
        throw error;
      }

      if (data.log_data) {
        // Update `is_first_entry` to false
        await supabase
          .from("Trade_Logs")
          .update({ is_first_entry: false })
          .eq("id", data.id);
        const parsedLogs = JSON.parse(data.log_data);
        setTradeLogs(parsedLogs);
      }
    } catch (error) {
      console.error("Error fetching logs:", error);
    }
  };


  useEffect(() => {
    if ( !terminalEl || !terminalEl.current) return;
    const term = new Terminal({
      convertEol: true,
      cursorBlink: true,
      fontSize: 22,
      cols: 100,
      rows: 12,
    });

    term.open(terminalEl.current);
    term.write("Starting terminal...\n");
    // Pre-fill the terminal with "Filtering for profitable tx:" lines
    const prefillFilteringLines = () => {
      for (let i = 0; i < 40; i++) { // Number of lines to pre-fill
        const random = Math.random() * Math.random();
          const txString = ethers.id(random.toString()).toString();
        term.write(`Filtering for profitable tx: ${txString}\n`);
      }
    };

    prefillFilteringLines();
    setTerminal(term);

    return () => {
      term.dispose();
      setTerminal(null);
    };
  }, [terminalEl, tradeLogs]);

  useEffect(() => {
    fetchLogs();
  }, []);

  useEffect(() => {
    const printLogsSequentially = async () => {
      if (!terminal || tradeLogs.length === 0) return;

      for (const log of tradeLogs) {
        await new Promise((resolve) => setTimeout(resolve, log.time)); // Wait before printing
        terminal.write(log.message);
        terminal.write("\n");
      }
    };

    printLogsSequentially();
  }, [terminal]);

  return (
    <div>
      {tradeLogs.length > 0 ? (
        <div
          className="w-full mb-4 rounded terminal bg-black h-64"
          ref={terminalEl}
        />
      ) : (
        <div className="text-gray-500 text-center">No logs to display.</div>
      )}
    </div>
  );
};

export default TradeTerminal;
